<style lang="less" scoped>
.cate-menu.el-menu--horizontal {
  border-bottom: none;
  > .el-menu-item {
    font-weight: bold;
    font-size: 16px;
    height: 40px;
    line-height: 40px;
    color: #595757;
    &.is-active {
      color: #409EFF;
    }
  }
}
</style>
<template>
  <div>
    <el-menu :default-active="currentTopCateId" class="cate-menu" mode="horizontal" @select="handleSelect">
      <el-menu-item v-if="activity.homeShow" index="home">
        首页
      </el-menu-item>
      <el-menu-item v-for="(cate) in topCates" :index="String(cate.id)">
        {{cate.cateName}}
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState: cateMapState } = createNamespacedHelpers('activityCate')
const { mapState: activityMapState } = createNamespacedHelpers('activity')

export default {
  computed: {
    ...cateMapState([
      'topCates',
      'currentTopCateId'
    ]),
    ...activityMapState([
      'activityId'
    ]),
  },
  methods: {
    handleSelect(cateId) {
      if(cateId == 'home') {
        this.$router.push({name: 'home'})
      } else {
        this.$router.push({name: 'list', query: {cateId}})
      }
    },
    getNavCate() {
      const matched = this.$route.matched
      const lastMatched = matched.slice(-1)[0]

      this.$store.dispatch('activityCate/getTopCate', this.activityId)
    }
  },
  watch: {
    $route() {
      this.getNavCate()
    },
    topCates: function (newValue, oldValue) {
      if (newValue.length > 0) {
        const state = this.$store.state.activityCate
      }
    }
  },
  mounted() {
    this.getNavCate()
  }
}
</script>
